<template>
    <slot v-bind="$attrs" />
</template>
